import { useTheme } from "@mui/material";
import { Children } from "react";
import styled from "styled-components";
import { TabPanelComponent } from "./helpers/tab-panel-component";



interface FormsWraperProps {
  value: number;
  buttonName: string[]
  forms: React.ReactNode[];
}

export const FormsWraper = ({ value, buttonName, forms }: FormsWraperProps) => {
  const themeMui = useTheme();

  return (
    <SummaryTableContainer >
      {buttonName.map((item) => (
        <TabPanelComponent
          value={value}
          key={buttonName.indexOf(item)}
          index={buttonName.indexOf(item)}
          dir={themeMui.direction}>
          {forms[buttonName.indexOf(item)]}
        </TabPanelComponent>))}
    </SummaryTableContainer >

  )
};
const SummaryTableContainer = styled.div`
  height: fit-content;
    `;


